import { render, staticRenderFns } from "./favourites.vue?vue&type=template&id=f63fc8e2"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f63fc8e2')) {
      api.createRecord('f63fc8e2', component.options)
    } else {
      api.reload('f63fc8e2', component.options)
    }
    module.hot.accept("./favourites.vue?vue&type=template&id=f63fc8e2", function () {
      api.rerender('f63fc8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/favourites.vue"
export default component.exports